var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 12.6667H27.1696C28.8166 12.6667 30.1886 13.9291 30.3254 15.5704L31.3809 28.237C31.5348 30.0833 30.0778 31.6667 28.2252 31.6667H9.77492C7.92229 31.6667 6.46534 30.0833 6.61919 28.237L7.67475 15.5704C7.81152 13.9291 9.18353 12.6667 10.8305 12.6667H12.6667M25.3334 12.6667H12.6667M25.3334 12.6667L25.3334 11.0833C25.3334 9.40363 24.6661 7.79272 23.4784 6.60499C22.2907 5.41726 20.6798 4.75 19.0001 4.75C17.3203 4.75 15.7094 5.41726 14.5217 6.60499C13.334 7.79272 12.6667 9.40363 12.6667 11.0833L12.6667 12.6667M25.3334 12.6667L25.3334 19M12.6667 12.6667L12.6667 19",
    stroke: "white",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e87b7309482c401643b551f0a66e60a2.svg";
export { ForwardRef as ReactComponent };